module.exports = __webpack_public_path__ + "img/logo-header.2a65d194.png";